module.exports = __webpack_public_path__ + "img/member-verify-icon-3.c8a11baa.png";